import React, { useState, useEffect } from "react";
import "./GioChamCong.css";

const GioChamCong = () => {
  const [maUser, setMaUser] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [allAttendanceData, setAllAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const tenUserFromStorage = localStorage.getItem("TenUser");
    const isAdminFromStorage = localStorage.getItem("isAdmin") === "true";
    setIsAdmin(isAdminFromStorage);
    if (tenUserFromStorage && !maUser) {
      setMaUser(tenUserFromStorage);
    }

    // Automatically set today's date
    const today = new Date().toISOString().split("T")[0];
    setSelectedDate(today);

    // Fetch all attendance data on load
    if (tenUserFromStorage) {
      fetchAllAttendance(tenUserFromStorage);
    }
  }, []);

  const fetchAllAttendance = async (maUser) => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch(
        `https://doticom.vn:3000/chamCongGetAll?MaUser=${maUser}`
      );

      if (!response.ok) {
        throw new Error("Không thể tải dữ liệu chấm công");
      }

      const data = await response.json();
      setAllAttendanceData(data);
      // Group by months
      const months = [
        ...new Set(
          data.map((record) => {
            const date = new Date(record.GioChamCong);
            return `${date.getFullYear()}-${String(
              date.getMonth() + 1
            ).padStart(2, "0")}`;
          })
        ),
      ].sort();
      // Set default to latest month
      if (months.length > 0) {
        setSelectedMonth(months[months.length - 1]);
        filterDataByMonth(months[months.length - 1], data);
      }
    } catch (err) {
      setError(err.message);
      setAllAttendanceData([]);
    } finally {
      setLoading(false);
    }
  };

  const filterDataByMonth = (month, data = allAttendanceData) => {
    const filtered = data.filter((record) => {
      const date = new Date(record.GioChamCong);
      const recordMonth = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;
      return recordMonth === month;
    });
    setFilteredData(filtered);
  };

  const handleMonthChange = (e) => {
    const month = e.target.value;
    setSelectedMonth(month);
    filterDataByMonth(month);
  };

  const handleSearch = async () => {
    if (!maUser) {
      setError("Vui lòng nhập mã nhân viên");
      return;
    }

    setLoading(true);
    setError("");

    try {
      let response;
      if (selectedDate) {
        response = await fetch(
          `https://doticom.vn:3000/chamcong?MaUser=${maUser}&Ngay=${selectedDate}`
        );
      } else {
        response = await fetch(
          `https://doticom.vn:3000/chamCongGetAll?MaUser=${maUser}`
        );
      }

      if (!response.ok) {
        throw new Error("Không thể tải dữ liệu chấm công");
      }

      const data = await response.json();
      setFilteredData(data);
    } catch (err) {
      setError(err.message);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateTime) => {
    const d = new Date(dateTime);
    const day = String(d.getUTCDate()).padStart(2, "0"); // Sử dụng ngày UTC
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatTime = (dateTime) => {
    const d = new Date(dateTime);
    const hours = String(d.getUTCHours()).padStart(2, "0"); // Sử dụng giờ UTC
    const minutes = String(d.getUTCMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const months = [
    ...new Set(
      allAttendanceData.map((record) => {
        const date = new Date(record.GioChamCong);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
          2,
          "0"
        )}`;
      })
    ),
  ].sort();

  return (
    <div className="gio-cham-cong-container">
      <div className="header">
        <h1>Giờ Chấm Công Khuôn Mặt</h1>
        <p>Nhập thông tin để xem lịch sử chấm công của nhân viên</p>
      </div>

      <div className="search-form">
        <div className="form-row">
          {isAdmin && (
            <div className="form-group">
              <label htmlFor="maUser">Mã nhân viên</label>
              <input
                type="text"
                id="maUser"
                value={maUser}
                onChange={(e) => setMaUser(e.target.value)}
                placeholder="Nhập mã nhân viên (VD: 3042001)"
                className="form-input"
              />
            </div>
          )}

          <div className="form-group">
            <label htmlFor="selectedMonth">Tháng</label>
            <select
              id="selectedMonth"
              value={selectedMonth}
              onChange={handleMonthChange}
              className="form-input"
            >
              {months.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="selectedDate">Ngày</label>
            <input
              type="date"
              id="selectedDate"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="form-input"
            />
          </div>

          <button
            onClick={handleSearch}
            disabled={loading}
            className="search-btn"
          >
            {loading ? "Đang tìm..." : "Tra cứu"}
          </button>
        </div>
      </div>

      {error && (
        <div className="error-message">
          <i className="error-icon">⚠️</i>
          {error}
        </div>
      )}

      {filteredData.length > 0 && (
        <div className="results-container">
          <h2>Kết quả tra cứu</h2>
          <div className="attendance-table">
            <div className="table-row header-row">
              <div className="date-cell">Ngày</div>
              <div className="entries-cell">
                {filteredData.map((record, index) => (
                  <div key={record.Id} className="entry-row">
                    <span className="entry-label">
                      {formatDate(record.GioChamCong)}
                    </span>
                    <span className="entry-time">
                      {formatTime(record.GioChamCong)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {!loading && filteredData.length === 0 && maUser && !error && (
        <div className="no-data">
          <i className="no-data-icon">📋</i>
          <p>Không tìm thấy dữ liệu chấm công</p>
        </div>
      )}
    </div>
  );
};

export default GioChamCong;
